import React from "react";
import { Mic } from "lucide-react";
import { useVoiceInput } from "./useVoiceInput";

const VoiceInput = ({ name, value, onChange, placeholder, required,label }) => {
  const { startListening, isListening } = useVoiceInput((text) => {
    onChange({ target: { name, value: text } });
  });

  return (
    <div className='w-full'>
       {label && (
        <label className="block text-sm font-medium mb-1">
    {label}
     
  </label>
        
      )}

    <div className="relative w-full">
      <input
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="w-full border rounded px-3 py-3 text-sm pr-20 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

       
      {/* Mic Button */}
      <button
        type="button"
        onClick={startListening}
        className={`absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-full transition duration-200
          ${isListening ? "bg-red-300 animate-pulse" : "bg-blue-100"}
        `}
      >
        <Mic
          size={18}
          className={isListening ? "text-red-600" : "text-blue-600"}
        />
      </button>
    </div>
        </div>
  );
};

export default VoiceInput;
